export default "__VITE_ASSET__C8om$4w7__"